import { ComplianceFramework } from '../types';

export const useComplianceFramework = (): ComplianceFramework => {
  const hostname = window.location.hostname.toLowerCase();

  if (hostname.endsWith('tanfed-stage.com') || hostname.endsWith('taniumfed.com')) {
    return ComplianceFramework.USGov;
  }
  return ComplianceFramework.None;
};
